var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefinicaoObjetivos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "definicao-objetivos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "definicao-objetivos_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.8,129.9c-2.3,0-4.1-1.8-4.1-4.1V53.3c0-2.3,1.8-4.1,4.1-4.1h6.8v16.3h41.1V49.2h6.6c2.3,0,4.1,1.8,4.1,4.1 V99l8.2-9.2V53.3c0-6.8-5.5-12.3-12.3-12.3H90.8c-1.7-4.8-6.3-8.2-11.6-8.2c-5.4,0-9.9,3.4-11.6,8.2H51.8 c-6.8,0-12.3,5.5-12.3,12.3v72.4c0,6.8,5.5,12.3,12.3,12.3h33.5l-8.6-8.2L51.8,129.9L51.8,129.9z M75,49.2v-4.1 c0-2.3,1.8-4.1,4.1-4.1c2.3,0,4.1,1.8,4.1,4.1v4.1h8.2v8H66.8v-8H75z M102.2,81.9H72.3v-8.2h29.8L102.2,81.9L102.2,81.9z  M64.1,73.7v8.2h-8.2v-8.2H64.1z M72.6,98.4v-8.2h29.6v8.2H72.6z M64.3,98.4h-8.4v-8.2h8.4V98.4z M55.9,106.6h8.2v8.2h-8.2 C55.9,114.8,55.9,106.6,55.9,106.6z M131.6,100.1l-34.2,38.1L75.1,117l5.7-6l16.1,15.4l28.6-31.8L131.6,100.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefinicaoObjetivos);
export default __webpack_public_path__ + "static/media/definicao-objetivos.ed8e9df71379a3028e9e4fa324b1f794.svg";
export { ForwardRef as ReactComponent };